import React from 'react';
import { Form } from 'reactstrap';

import AdminFTPQueueFiltersSelected from './FiltersSelected';
import AdminFTPQueueFilterStatuses from './FilterStatuses';

const AdminFTPQueueFilters = props => (
  <div className="ftp-queue-filters content-wrapper">
    <AdminFTPQueueFiltersSelected {...props} />
    <Form inline>
      <AdminFTPQueueFilterStatuses {...props} />
    </Form>
  </div>
);

export default AdminFTPQueueFilters;
